import React, { useLayoutEffect, useRef, useState } from 'react';

export default function InlineEditableTitle({
  isEditing = false,
  value = '',
  displayValue = '',
  placeholder = 'Title',
  onStartEditing,
  onChange,
  onCommit,
  onCancel,
  rowClassName = '',
  displayClassName = '',
  inputClassName = '',
  inputStyle,
  displayTitle = 'Click to edit title',
}) {
  const skipBlurCommitRef = useRef(false);
  const displayRef = useRef(null);
  const [lockedWidth, setLockedWidth] = useState(null);

  useLayoutEffect(() => {
    if (isEditing) return;
    if (!displayRef.current) return;
    const nextWidth = Math.ceil(displayRef.current.getBoundingClientRect().width);
    if (nextWidth > 0) {
      setLockedWidth(nextWidth);
    }
  }, [isEditing, displayValue]);

  const commit = async () => {
    if (typeof onCommit === 'function') {
      await onCommit();
    }
  };

  const mergedInputStyle = {
    ...(inputStyle || {}),
    width: '100%',
    maxWidth: '100%',
  };

  const shellStyle = lockedWidth
    ? { width: `${lockedWidth}px`, maxWidth: '100%' }
    : undefined;

  if (isEditing) {
    return (
      <div className={rowClassName}>
        <div className="inline-editable-title-shell" style={shellStyle}>
          <input
            className={inputClassName}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            placeholder={placeholder}
            autoFocus
            style={mergedInputStyle}
            onBlur={async () => {
              if (skipBlurCommitRef.current) {
                skipBlurCommitRef.current = false;
                return;
              }
              await commit();
            }}
            onKeyDown={async (e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                skipBlurCommitRef.current = true;
                await commit();
              } else if (e.key === 'Escape') {
                e.preventDefault();
                skipBlurCommitRef.current = true;
                if (typeof onCancel === 'function') onCancel();
              }
            }}
          />
        </div>
      </div>
    );
  }

  return (
    <div className={rowClassName}>
      <div className="inline-editable-title-shell">
        <h3
          ref={displayRef}
          className={displayClassName}
          onClick={onStartEditing}
          title={displayTitle}
        >
          {displayValue}
        </h3>
      </div>
    </div>
  );
}
